const numbersOnly = newVal => {
    return newVal.replace(/\D+/g,'');
};

export { numbersOnly }